import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/share';

@Injectable()
export class SpinnerService {
  public status: Subject<Object> = new Subject();
  private _type: number = 0; // default spinner
  private _active: boolean = false;

  public set_active(v: boolean, t: number) {
    this._active = v;
    this._type = t;
    this.status.next({status: v, type: t});
  }

  public start(type: number = 0): void {
    this.set_active(true, type);
  }

  public stop(): void {
    this.set_active(false, 0);
  }
}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/utilities/spinner/spinner.service.ts